import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimWhitespace'
})
export class TrimWhitespacePipe implements PipeTransform {
  transform(value: string | null): string {
    if (value != null) {
      return value.replace(/\s/g, '');
    } else {
      return '';
    }
  }
}
